import { prefixClassName } from '../../../../components/ui/_conf';

export const clx = prefixClassName('bulk-block-slots');

export const BLOCK_SLOTS_FORM = {
  NAME: 'bulkBlockSlots',
  FIELDS: {
    SHOPPING_MODE: 'blockSlotShoppingMode',
    STORES: 'blockSlotStores',
    NOTE: 'blockSlotNote',
    TIMES: 'blockSlotTimes',
    TIME: {
      ID: 'id',
      DAY: 'day',
      START: 'start',
      END: 'end',
    },
  },
} as const;

export const ACTIONS = {
  SUBMIT_BULK_BLOCKING_SLOTS: 'SUBMIT_BULK_BLOCKING_SLOTS',
} as const;

export const TRANSLATIONS = {
  FIELDS: {
    SHOPPING_MODE: { LABEL: 'modules.slotManagement.bulkBlockingSlots.panels.shoppingModesLabel' },
    NOTE: {
      LABEL: 'modules.slotManagement.bulkBlockingSlots.panels.noteLabel',
      PLACEHOLDER: 'modules.slotManagement.bulkBlockingSlots.panels.notePlaceholder',
      EXPLAINER: 'modules.slotManagement.bulkBlockingSlots.panels.noteExplainer',
    },
    STORES: {
      CAPTION_01: 'modules.slotManagement.bulkBlockingSlots.panels.storeCaption01',
      CAPTION_02: 'modules.slotManagement.bulkBlockingSlots.panels.storeCaption02',
    },
    TIME: {
      DAY: 'modules.slotManagement.bulkBlockingSlots.panels.timeDay',
      START: 'modules.slotManagement.bulkBlockingSlots.panels.timeStart',
      END: 'modules.slotManagement.bulkBlockingSlots.panels.timeEnd',
      ADD_TIME: 'modules.slotManagement.bulkBlockingSlots.panels.timeAddBtn',
    },
  },
  FORM: {
    HEADER: {
      WARNING: 'modules.slotManagement.bulkBlockingSlots.header.warning',
    },
    FOOTER: {
      SUBMIT_BTN: 'modules.slotManagement.bulkBlockingSlots.footer.submitBtn',
      RESET_BTN: 'modules.slotManagement.bulkBlockingSlots.footer.reset',
    },
  },
  TOAST: {
    SUCCESS: 'modules.slotManagement.bulkBlockingSlots.toast.success',
    SUCCESS_PARTIAL: 'modules.slotManagement.bulkBlockingSlots.toast.successPartial',
    WARNING: 'modules.slotManagement.bulkBlockingSlots.toast.warning',
    REMAINING: 'modules.slotManagement.bulkBlockingSlots.toast.remaining',
    ERROR: 'modules.slotManagement.bulkBlockingSlots.toast.error',
    DOWNLOAD_BTN: 'modules.slotManagement.bulkBlockingSlots.toast.downloadDetails',
  },
  CSV_TABLE: {
    STORE: 'modules.slotManagement.bulkBlockingSlots.csvReportTable.store',
    START: 'modules.slotManagement.bulkBlockingSlots.csvReportTable.start',
    END: 'modules.slotManagement.bulkBlockingSlots.csvReportTable.end',
    ERROR: 'modules.slotManagement.bulkBlockingSlots.csvReportTable.error',
    FILENAME: 'FailedBlockingSlots',
  },
  ERRORS: {
    END_TIME_BEFORE_START_TIME: 'modules.slotManagement.bulkBlockingSlots.panels.timeErrorEndBeforeStart',
  },
} as const;
